import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import ArticleCard from "@/components/public/ArticleCard";
import SEO from "@/components/SEO";

export default function CategoryPage() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/categories/${slug}`).then((r) => setCat(r.data)).catch(() => {});
    api.get(`/articles?category=${slug}&limit=60`).then((r) => setArticles(r.data || [])).catch(() => {});
  }, [slug]);

  return (
    <div>
      <SEO title={cat?.name} description={cat?.description} image={cat?.image} />
      <div className="relative h-[45vh] min-h-[340px] bg-sunset-ink overflow-hidden">
        {cat?.image && <img src={mediaUrl(cat.image)} alt="" className="w-full h-full object-cover opacity-60" />}
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col justify-end pb-14">
          <p className="kicker text-white/80 mb-3">Categoría</p>
          <h1 className="font-serif text-white text-5xl md:text-6xl tracking-tight">{cat?.name || slug}</h1>
          {cat?.description && <p className="text-white/70 mt-4 max-w-xl">{cat.description}</p>}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 min-h-[40vh]">
        {articles.length === 0 ? (
          <p className="text-sunset-muted py-16 text-center">Aún no hay artículos en esta categoría.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
            {articles.map((a, i) => <ArticleCard key={a.id} article={a} size="md" index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
